import { render, staticRenderFns } from "./ComparisonNode.vue?vue&type=template&id=5a6f6e03&scoped=true"
import script from "./ComparisonNode.vue?vue&type=script&lang=js"
export * from "./ComparisonNode.vue?vue&type=script&lang=js"
import style0 from "./ComparisonNode.vue?vue&type=style&index=0&id=5a6f6e03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6f6e03",
  null
  
)

export default component.exports